
import Loadable from 'app/components/Loadable';
import { lazy } from 'react';


const Opportunities = Loadable(lazy(() => import('./Opportunities')));
const Network = Loadable(lazy(() => import('./Network')));
const Hire = Loadable(lazy(() => import('./Hire')));



const ArtiztHomeRoutes = [
  { path: '/artizthome/opportunities', element: <Opportunities /> },
  { path: '/artizthome/network', element: <Network /> },
  { path: '/artizthome/hire', element: <Hire /> },



];

export default ArtiztHomeRoutes;
